import { PlaceType } from '@th/shared/src/types/PlaceType';

export const MAPBOX_PUBLIC_ACCESS_TOKEN =
  'pk.eyJ1IjoidG9tc2tvcGVrIiwiYSI6ImNrdTdkdzZ2ODIyamQyeG1wZmZ4cjRqbTEifQ.yINH49Dj4n4IQ26w-q6tOA';

export const GEO_AREA_TYPES_WITH_PIN = [
  PlaceType.Street,
  PlaceType.Address,
  PlaceType.Intersection,
];
